var url = "";
if (window.location.host === "star-kuwait-qr.nuviotech.co") {
  url = "https://star-kuwait-api.nuviotech.co";
} else {
  // url = 'http://localhost:3800'
  url = "https://kuwait-cron-api.starcinemas.com";
}
export const URL_BASE = url;



// WEBPACK FOOTER //
// ./src/helper/constants.js